import React from 'react';
import MainLayout from '../components/Layout/MainLayout';
import ScanHistory from '../components/Scan/ScanHistory';

const HistoryPage = () => (
  <MainLayout><ScanHistory /></MainLayout>
);

export default HistoryPage;